<template>
  <div>
    <div class="form-group">
      <label for="card_number">Credit Card Number</label>
      <div class="form-control mb-3" id="card_number"></div>
      <div class="text-danger" v-if="stripeError && stripeError.code==='incomplete_number'">
        {{stripeError.message}}
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label for="card_expiry">Expiration Date</label>
          <div  class="form-control mb-3 form-input" id="card_expiry"></div>
          <div class="text-danger" v-if="stripeError && stripeError.code==='incomplete_expiry'">{{stripeError.message}}</div>
        </div>
      </div>

      <div class="col-4">
        <div class="form-group">
          <label for="card_cvc">Security Code</label>
          <div  class="form-control mb-3" id="card_cvc"></div>
          <div class="text-danger" v-if="stripeError && stripeError.code==='incomplete_cvc'">{{stripeError.message}}</div>
        </div>
      </div>

      <div class="col-4">
        <div class="form-group">
          <label for="postal_code">Postal Code</label>
          <input type="text" class="form-control mb-3" id="postal_code" v-model="postalCode">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

class StripeError extends Error {
  constructor (error, ...params) {
    super(`${error.type} - ${error.message}`, ...params)
    this.stripeError = error
    this.code = error.code
    this.type = error.type
  }
}

var elementStyles = {
  base: {
    color: '#32325D',
    fontWeight: 500,
    lineHeight: 1.5,
    fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
    fontSize: '15px',
    fontSmoothing: 'antialiased',

    '::placeholder': {
      color: '#CFD7DF'
    },
    ':-webkit-autofill': {
      color: '#e39f48'
    }
  },
  invalid: {
    color: '#E25950',

    '::placeholder': {
      color: '#FFCCA5'
    }
  }
}

var elementClasses = {
  focus: 'focused',
  empty: 'empty',
  invalid: 'invalid'
}

export default {
  name: 'payment-form',
  data () {
    return {
      // Form fields
      postalCode: null,
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',
      // Stripe
      stripe: null,
      stripeError: null,
      loading: false
    }
  },
  mounted: function () {
    const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY)
    this.stripe = stripe
    const elements = stripe.elements({
      fonts: [
        {
          cssSrc: 'https://fonts.googleapis.com/css?family=Titillium+Web'
        }
      ]
    })
    this.cardNumber = elements.create('cardNumber', {
      style: elementStyles,
      classes: elementClasses
    })
    this.cardNumber.mount('#card_number')

    this.cardExpiry = elements.create('cardExpiry', {
      style: elementStyles,
      classes: elementClasses
    })
    this.cardExpiry.mount('#card_expiry')

    this.cardCvc = elements.create('cardCvc', {
      style: elementStyles,
      classes: elementClasses
    })
    this.cardCvc.mount('#card_cvc')
  },
  methods: {
    proceed: function (data) {
      return this.stripe.createSource(this.cardNumber, {
        owner: {
          name: data.owner.name,
          email: data.owner.email,
          address: {
            postal_code: this.postalCode
          }
        }
      }).then((response) => {
        if (response.error) {
          this.stripeError = response.error
          throw new StripeError(response.error)
        }
        return response
      })
    }
  }
}
</script>
